import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const JourneyRoutes = [
  {
    path: '/journeys',
    name: 'ListJourneys',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'journey:list'
    }
  },
  {
    path: '/journey/',
    name: 'CreateJourney',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'journey:create'
    }
  },
  {
    path: '/journey/:id',
    name: 'UpdateJourney',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'journey:update'
    }
  },
  {
    path: '/journey/view/:id',
    name: 'GetJourney',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'journey:get'
    }
  }
]
